import { Banner, Caption, Flex_unstable as Flex, Heading } from '@farol-ds/react'

import styles from './variant-c.module.scss'

export interface VariantCProps {
  title: string
  description: string
  buttonContent: React.ReactNode
}

const MESSAGE_LABEL = 'Resposta'
const MESSAGE_TEXT =
  'Com base nas informações públicas disponíveis e nas regras previstas na legislação brasileira, uma possível explicação para essa dúvida é...'
const CAPTION_BELOW_BUTTON =
  'Faça perguntas, entenda seus direitos e seja conectado com advogados especializados'

export function VariantC({ title, description, buttonContent }: VariantCProps) {
  return (
    <Flex direction="column" gap="3xs" align="center">
      <Flex direction="column" align="center" gap="6xs" className={styles.textBlock}>
        <Heading size="md">{title}</Heading>
        <Caption className={styles.description}>{description}</Caption>
      </Flex>
      <Banner type="discovery">
        <Banner.Content>
          <Banner.Title>{MESSAGE_LABEL}</Banner.Title>
          <Banner.Description>{MESSAGE_TEXT}</Banner.Description>
        </Banner.Content>
      </Banner>
      <Flex direction="column" align="center" gap="5xs" className={styles.buttonSection}>
        <Flex justify="center" className={styles.buttonContainer}>
          {buttonContent}
        </Flex>
        <Caption className={styles.captionBelow}>{CAPTION_BELOW_BUTTON}</Caption>
      </Flex>
    </Flex>
  )
}
